<form class="pre-form" #formulari="ngForm">            
    <mat-grid-list cols="4" rows="3" rowHeight="80px">                              
        <mat-grid-tile>
            <mat-form-field class="pre-field">
                <mat-select name="coneixementMaster" placeholder="Coneixement del màster" [compareWith]="compareConeixementMaster"
                [ngModel]="preinscripcio.coneixementMaster" required (ngModelChange)="coneixementMasterChange($event)" i18n-placeholder>
                    <mat-option *ngFor="let x of comConegutList" [value]="x">
                        {{ x?.name }}
                    </mat-option>
                </mat-select>
                <mat-hint align="start" i18n>Indica per quin mitjà heu conegut el màster</mat-hint>
            </mat-form-field>  
        </mat-grid-tile>
        <mat-grid-tile *ngIf="preinscripcio.oferta.demanarPresencial">
            <mat-form-field class="pre-field">
                <mat-select name="presencialitat" placeholder="Modalitat d'ensenyament" [(ngModel)]="preinscripcio.presencialitat" required>
                    <mat-option *ngFor="let td of presencialitats" [value]="td.value" i18n-placeholder>
                        {{ td.name }}
                    </mat-option>
                </mat-select>
                <mat-hint align="start" i18n>Indica per quina modalitat d’ensenyament opteu</mat-hint>
            </mat-form-field>  
        </mat-grid-tile>
        <mat-grid-tile colspan="2" *ngIf="preinscripcio.oferta.conveniDobleTitulacio">
            <mat-checkbox name="conveniDobleTitulacio" placeholder="Hola" class="pre-controls-left" [(ngModel)]="preinscripcio.conveniDobleTitulacio" i18n>T'has inscrit a la convocatòria pública de doble titulació de la teva universitat</mat-checkbox>        
        </mat-grid-tile>           
        <mat-grid-tile *ngIf="preinscripcio.conveniDobleTitulacio">
            <mat-form-field class="pre-field">
                <mat-select name="universitatDobleTitulacio" placeholder="Universitat de doble titulació" [compareWith]="compareuniversitatDobleTitulacio"
                [ngModel]="preinscripcio.universitatDobleTitulacio" required (ngModelChange)="universitatDobleTitulacioChange($event)" i18n-placeholder>
                    <mat-option *ngFor="let x of universitatsDobleTitulacioList" [value]="x">
                        {{ x?.name }}
                    </mat-option>
                </mat-select>
                <mat-hint align="start" i18n>Indica la teva universitat d'origen</mat-hint>
            </mat-form-field>  
        </mat-grid-tile>
    
        <mat-grid-tile colspan="4" *ngIf="preinscripcio.potModificar">
            <div class="pre-controls-right">
                <button mat-raised-button matStepperPrevious i18n>Torna</button>
                <button mat-raised-button color="primary" (click)="continua()" [disabled]="!isValid()" i18n>Continua</button>            
            </div>
        </mat-grid-tile>
    </mat-grid-list>
</form>


// WEBPACK FOOTER //
// ./src/app/altres/altres.component.html